import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/utils/utils";

const variants = cva(
  "absolute  size-[364px] rounded-full bg-[#D1D2FF6B] blur-[150px]",
  {
    variants: {
      variant: {
        "top-left": "left-[-285px] top-[-246px]",
        "bottom-right": "right-[-134px] bottom-[-271px]",
      },
    },
    defaultVariants: {
      variant: "top-left",
    },
  },
);

type Props = {
  variant: VariantProps<typeof variants>["variant"];
  className?: string;
};

export default function BlurredLightEffect({ variant, className }: Props) {
  return <div className={cn(variants({ variant, className }))} />;
}
